export default "__VITE_ASSET__CkjtiVYt__"